<template>
  <div>
    <projectAddUser v-if="showModal" :project="project" @close="reload()"></projectAddUser>
    <DataTable
      v-if="users"
      :value="users"
      :loading="loading"
      rowGroupMode="subheader" 
      groupRowsBy="access"  
      sortMode="single" 
      sortField="access" 
      :sortOrder="1"
    >
      <Column field="name" header="Navn">
        <template #body="slotProps">
          <p>{{ slotProps.data.name }}{{isOwner(slotProps.data)}}</p> 
        </template>
      </Column>
      <Column field="Email" header="E-post">
        <template #body="slotProps">
              <p>{{ slotProps.data.Email }}</p> 
        </template>
      </Column>
      <Column field="phone" header="Telefon"></Column>
      <template #footer v-if="!disabled">
        <div class="p-d-flex p-jc-end"> 
          <Button label="Endre" icon="pi pi-users" @click="edit()"/>
        </div>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

import projectAddUser from '@/components/projects/projectAddUser'

export default {
name: 'projectUsers',

components:{
  DataTable,
  Column,
  projectAddUser
},

props: {
  disabled: {
    type: Boolean, 
    default: false,
  }
},

data(){
  return{
    loading: false,
    showModal: false
  }
},

mounted(){
  this.loading = true
  this.$store.dispatch('employees/inspect', {id: this.project.useraccess, type: 'project'}).then(() => {
    this.loading = false
  })
},

methods: {
  removeAccsess(employee){
    this.$store.dispatch('projects/update', {id: this.project.id, data: { useraccess: this.project.useraccess.filter(item => item == employee.id) }}) 
  },
  
  openModal(){
    this.loading = true 
    this.showModal = true
  },
  
  reload(){
    this.showModal = false 
    this.loading = true
    this.$store.dispatch('employees/inspect', {id: this.project.useraccess, type: 'project'}).then(() => {
      this.loading = false
    })
  },
  
  isOwner(employee){
    if(this.project.owner.uid == employee.uid){
      return ' (Prosjekteier)'
    }
  },
  
  edit(){
    this.$router.push({name: 'projectUsersEdit', params: {id: this.project.id}})
  }
},

computed:{
  users(){
    return this.$store.getters["employees/inspect"]
  },
  project(){
    return this.$store.getters["projects/inspect"]
  }
}
  
}
</script>